import { useEffect } from "react";
import PermitTypesList from "../components/PermitTypesList";
import { useAppContext } from "../hooks/useAppContext";
import { useLazyGetPermitTypesByOrganizationId } from "../operations/queries/getPermitTypesByOrganizationId";
import { useLazyGetOrgRolesByOrganizationId } from "../operations/queries/getOrgRolesByOrganizationId";
import { useLazyGetDocumentTypesByOrganizationId } from "../operations/queries/getDocumentTypesByOrganizationId";
import { useUpdatePermitType } from "../operations/mutations/updatePermitType";

const PermitTypesListContainer = () => {
  const { currentOrganization } = useAppContext();
  const organizationId = currentOrganization?.id ?? "";

  const {
    getPermitTypesByOrganizationId: getPermitTypes,
    data: permitTypesData,
  } = useLazyGetPermitTypesByOrganizationId();

  const {
    getOrgRolesByOrganizationId,
    data: orgRolesData,
  } = useLazyGetOrgRolesByOrganizationId();

  const {
    getDocumentTypesByOrganizationId,
    data: documentTypesData,
  } = useLazyGetDocumentTypesByOrganizationId();

  const { mutate: updatePermitTypeMutate, status: updatePermitTypeStatus } = useUpdatePermitType(organizationId);

  useEffect(() => {
    if (currentOrganization) {
      getPermitTypes({ variables: { organizationId: currentOrganization.id } });
      getOrgRolesByOrganizationId({ variables: { organizationId: currentOrganization.id } });
      getDocumentTypesByOrganizationId({ variables: { organizationId: currentOrganization.id } });
    }
  }, [currentOrganization, getPermitTypes, getOrgRolesByOrganizationId, getDocumentTypesByOrganizationId]);

  const handleEdit = (orgId: string, permitTypeId: string, name: string, templateJson?: string) => {
    updatePermitTypeMutate({
      variables: {
        organizationId: orgId,
        permitTypeId,
        name,
        templateJson,
      },
    });
  };

  return (
    <PermitTypesList
      organizationId={organizationId}
      permitTypes={permitTypesData?.permitTypesByOrganizationId}
      allOrgRoles={orgRolesData?.orgRolesByOrganizationId}
      allDocumentTypes={documentTypesData?.documentTypesByOrganizationId}
      onEdit={handleEdit}
      editStatus={updatePermitTypeStatus}
    />
  );
};

export default PermitTypesListContainer;

